import { combineReducers } from "@reduxjs/toolkit";
import { viewUtilsReducer } from "./viewUtils/viewUtilsReducer";
import { userReducer } from "./user/userReducer";

export const rootReducer = combineReducers({
  viewUtils: viewUtilsReducer,
  user: userReducer,
});
